import * as React from 'react';
import {View} from 'react-native';
import {useStyles} from '../../../../../../shared/hooks/styles';
import {Button} from '../../../../../../shared/components/button';
import {ProductPriceFilterList} from '../../list';
import {ProductsPriceFilterViewBaseProps} from '../../../model';

export default ({productPrices, onSubmit}: ProductsPriceFilterViewBaseProps) => {
  const styles = useStyles(() => ({
    container: {
      paddingBottom: 30,
    },
    filterButtonContainer: {},
    filterButton: {},
  }));
  return (
    <View style={styles.container}>
      <ProductPriceFilterList visuallyImpaired productPrices={productPrices} />
      <View style={[styles.filterButtonContainer]}>
        <Button id='filter-show' text='Показать' type='secondary' style={styles.filterButton} onPress={onSubmit} />
      </View>
    </View>
  );
};
